import { Badge } from '@/components/ui/badge';
import { ReceivingStatusEnum } from '../types/receiving.types';

export const receivingStatusConfig: Record<
  ReceivingStatusEnum,
  { label: string; variant: 'secondary' | 'warning' | 'success' | 'destructive' | 'outline' }
> = {
  [ReceivingStatusEnum.PendingPutAway]: { label: 'Pending Put-Away', variant: 'secondary' },
  [ReceivingStatusEnum.PartiallyPutAway]: { label: 'Partially Put-Away', variant: 'warning' },
  // 86d3rrgt5 — distinct labels: PutAwayComplete (4) = binned, IR not yet posted;
  // Completed (1) = Item Receipt posted to NetSuite. Same badge before hid which was which.
  [ReceivingStatusEnum.PutAwayComplete]: { label: 'Put-Away Complete', variant: 'success' },
  [ReceivingStatusEnum.Completed]: { label: 'Posted to NetSuite', variant: 'success' },
  [ReceivingStatusEnum.Cancelled]: { label: 'Cancelled', variant: 'destructive' },
};

export function ReceivingStatusBadge({ status }: { status: ReceivingStatusEnum }) {
  const config = receivingStatusConfig[status] ?? { label: 'Unknown', variant: 'secondary' as const };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
